module.exports = __webpack_public_path__ + "img/offline-private-deployment.c6530f14.webp";